import React from "react";
import useLanguageChange from "../../hooks/useLanguageChange";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import markupService from "../../services/MarkupService/markupService";
import { MARKUP_MENU_TYPE } from "../../constants/MarkupConstants";
import UploadFileMarkupService from "../../services/UploadFileMarkupService/UploadFileMarkupService";

const UndoButton = ({ fromMarkup }) => {
    const localisedValues = useLanguageChange();
    const { undoEnabled } = useSelector((state) => state.markup);
    return (
        <div className='markup-menu-item' data-testid='markup-edit-menu-bar'>
            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                <button
                    className='btn markup-menu-btn'
                    onClick={() => {
                        fromMarkup === MARKUP_MENU_TYPE.MARKUP_ANNOTATION
                            ? markupService.undoLocalObject()
                            : UploadFileMarkupService.undoMarkupLocalObject();
                    }}
                    disabled={!undoEnabled}
                    data-testid='markup-edit-menu-button'
                >
                    <span className='btn-icon icon-undo'></span>
                    <span className='moremenu-text'>{localisedValues?.undo}</span>
                </button>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in'>
                        <p>{localisedValues?.undo}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

UndoButton.propTypes = {
    fromMarkup: PropTypes.string,
};
export default UndoButton;
